import ValidationEngine from 'devextreme/ui/validation_engine';

import { deleteNotification } from '@/services/api';

import showConfirmDialog from '@/components/confirm-dialog';
import showErrorDialog from "@/views/notification/error-dialog"
import { scheduleTypeDataSourceConfig, weekDaysArr } from '@/views/notification/constants';

import { notifier } from '@/shared/lib/notifier/index';

export const notificationMixin = {
    data() {
        return {
            dataNotif: {
                notification: { subject: null, subscribers: [], isEditable: true },
                scheduleDetail: null,
            },
            loading: false,
            saving: false, 
            deleting: false,
            testing: false,
            colCountByScreen: {
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2
            },
            colCountByScreenSchedule: {
                xs: 1,
                sm: 1,
                md: 3,
                lg: 3
            },
            colCountByScreenScheduleAction: {},
            editorSettings: {
                id: { readOnly: true },
                active: { width: '50px' },
                description: { height: '95px' },
                scheduleDetail: {
                  dataSource: scheduleTypeDataSourceConfig,
                  displayExpr: 'text',
                  valueExpr: 'id'
                },
                time: {
                  pickerType: 'rollers',
                  type: 'time',
                  width: '110px'
                }
            },
            flVisibleScheduleDetailWeekly: false,
            flVisibleScheduleDetailMonthly: false,
            flVisibleScheduleDetailMonthlyDayOfMonth: false,
            flVisibleScheduleDetailTime: true,
            weekDays: weekDaysArr,
            weekDaysKey: ["MON"],
        }
    },
    computed: {
        isEditableForm() {
            if (typeof this.dataNotif.notification.isEditable === 'boolean')
                return this.dataNotif.notification.isEditable;
            else
                return true;
        },
        dataForm() {
            return this.$refs[this.formRefName] ? this.$refs[this.formRefName].instance : null;
        },
        testDisabled() {
            return !this.dataNotif.notification
              || !this.dataNotif.notification.subscribers
              || (this.dataNotif.notification.subscribers.length === 0 && !this.dataNotif.notification.includeSystemSubscribers);
        },
    },
    methods: {
          validate() {
            return ValidationEngine.validateGroup("notificationValidation");
          },
          async validateValues() {
            if (this.dataNotif.scheduleDetail !== null && this.dataNotif.scheduleDetail != undefined  && "id" in this.dataNotif.scheduleDetail &&
               this.dataNotif.scheduleDetail.id == "WEEKLY") {
              
              if (!("days" in this.dataNotif.scheduleDetail.weeks && this.dataNotif.scheduleDetail.weeks.days.length !== 0)) {
                const response = await showErrorDialog({
                  title: this.$t('general.error'),
                  message: this.$t('notification.error.weekdays'),
                  btnType: 'default',
                  okButton: this.$t('general.close'),
                });
      
                return response;
              }
            }
      
            return true;
        },    
        async onSave() {
            const validate = this.validate();
            if (!validate.isValid) {
                validate.brokenRules[0].validator.focus();  
                return;
            }
    
            const response = await showConfirmDialog({
                title: this.$t('general.save'),
                message: this.$t('notification.save.confirm'),
                btnType: 'default',
                okButton: this.$t('general.proceed'),
                cancelButton: this.$t('general.cancel'),
            });
            if (!response)
                return;
    
            await this.save();
        },
        selectWeekDays(e) {
            if (e.addedItems[0])
                this.dataNotif.scheduleDetail.weeks.days.push(e.addedItems[0].id);
            if (e.removedItems[0])
                this.dataNotif.scheduleDetail.weeks.days.splice(this.dataNotif.scheduleDetail.weeks.days.indexOf(e.removedItems[0].id),1);
        },
        updateScheduleDetailVisibility(value) {
            const scheduleDetail = this.dataNotif && this.dataNotif.scheduleDetail;

            this.flVisibleScheduleDetailWeekly = value === 'WEEKLY';
            this.flVisibleScheduleDetailMonthly = value === 'MONTHLY';
            this.flVisibleScheduleDetailTime = value !== 'IMMEDIATELY';

            if (value === 'WEEKLY') {
                if (!scheduleDetail.weeks || !Array.isArray(scheduleDetail.weeks.days)) {
                    this.$set(scheduleDetail, 'weeks', { days: ['MON'] });
                }

                this.weekDaysKey = scheduleDetail.weeks.days;
                this.colCountByScreenScheduleAction = {
                    xs: 1,
                    sm: 1,
                    md: 2,
                    lg: 2
                };
                return;
            }

            if (value === 'MONTHLY') {
                this.flVisibleScheduleDetailMonthlyDayOfMonth = !!(scheduleDetail.monthly && scheduleDetail.monthly.lastdayofmonth);
                this.colCountByScreenScheduleAction = {
                    xs: 1,
                    sm: 1,
                    md: 3,
                    lg: 3
                };
                return;
            }

            this.colCountByScreenScheduleAction = {};
        },
        normalizeScheduledOnlyDetail(fallbackId = 'DAILY') {
            const scheduleDetail = this.dataNotif && this.dataNotif.scheduleDetail;
            const notification = this.dataNotif && this.dataNotif.notification;

            if (!scheduleDetail || !notification)
                return;

            if (scheduleDetail.id === 'IMMEDIATELY')
                this.$set(scheduleDetail, 'id', fallbackId);

            notification.isScheduled = true;
            this.updateScheduleDetailVisibility(scheduleDetail.id);
        },
        async onDelete() {
            const response = await showConfirmDialog({
                title: this.$t('general.delete'),
                message: this.$t('notification.delete.confirm'),
                btnType: 'default',
                okButton: this.$t('general.proceed'),
                cancelButton: this.$t('general.cancel'),
            });
            if (!response)
                return;

            try {
                this.deleting = true;
                await deleteNotification(this.dataNotif.notification.id);
                notifier.showSuccess(this.$t('general.deleteSuccess'));
                setTimeout(() => this.$router.go(-1));
            } catch(err) {
                this.onDataError(err);
            } finally {
                this.deleting = false;
            }
        },
        async onTest() {
            const validate = this.validate();
            if (!validate.isValid) {
                validate.brokenRules[0].validator.focus();  
                return;
            }
    
            this.testing = true;
            try {
                const response = await showConfirmDialog({
                    title: this.$t('notification.testSave.title'),
                    message: this.$t('notification.testSave.message'),
                    btnType: 'default',
                    okButton: this.$t('general.proceed'),
                    cancelButton: this.$t('general.cancel'),
                });
                if (!response)
                    return;
                await this.save(true/* test */);
            } finally {
                this.testing = false;
            }
        },
        // удаление специй не относящихся к заданному уведомлению
        fixAcceptableSpices(text) {
            if (!text)
                return;

            // улучшить .
            let result = text.match(/data-var-value="(.*?)">/g);

            if (result) {
                result = result.map(function(val){
                    return val.replace('data-var-value="', '').replace('">', '');
                });

                const replacementWords = result.filter(x => !this.specificationsDictionary.includes(x));
                replacementWords.forEach(word => {
                    // eslint-disable-next-line no-irregular-whitespace
                    const pattern = `<span class="dx-variable" data-var-start-esc-char="" data-var-end-esc-char="" data-var-value="${word}">﻿<span contenteditable="false">${word}</span>﻿</span>`;
                    text = text.replaceAll(pattern, '');
                });
            }
            return text;
        }
    },
    watch: {
        'dataNotif.scheduleDetail.id': {
          handler(value) {
            if (!value)
              return;

            this.updateScheduleDetailVisibility(value);
          },
          immediate: true
        },
    }
};